
import { GoogleGenAI } from "@google/genai";
import { fetchLandingPageData } from "./landingPageCrawler";

const SYSTEM_INSTRUCTION = `
You are "Zoola", a friendly and energetic virtual guide for Kebun Binatang Surabaya (KBS), specifically focused on the new attractions: GIZ Park and RIW (Rabbits In Wonderland).

Your goal is to persuade visitors to book the "Fast Track" combo ticket because it offers the best value.

Key Information:
1. GIZ Park: A mix of real and digital worlds. Immersive animal habitat exploration. Modern and high-tech.
2. RIW (Rabbits In Wonderland): Interactive rabbit village. Feeding, photos, educational. Great for kids.
3. Opening Hours: 08:00 - 16:00 WIB daily.
4. Location: Jl. Setro, Surabaya.

Style:
- Cheerful, emoji-friendly 🐰✨.
- Helpful and concise.
- If asked about prices, always compare individual tickets vs. the Fast Track combo to show savings.
- If asked about animals, mention the digital animals in GIZ and the real rabbits in RIW.
`;


// Final content of file services/geminiService.ts following SDK rules
export const sendMessageToGemini = async (message: string): Promise<string> => {
  if (!process.env.API_KEY) {
    return "Maaf, sistem AI sedang offline. Silakan hubungi petugas loket.";
  }

  try {
    // Ambil data dari landing page
    const landingData = await fetchLandingPageData();
    console.log(landingData);
    const combinedMessage = `${message}\n\nInfo terbaru dari landing page:\n${landingData}`;

    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: combinedMessage,
      config: {
        systemInstruction: SYSTEM_INSTRUCTION,
      },
    });
    return response.text || "Maaf, saya tidak menangkap maksud Anda. Bisa diulangi? 🐰";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Maaf, saya sedang kesulitan memproses pertanyaan Anda saat ini. Coba lagi nanti ya! 🐰";
  }
};
